import React, { isValidElement, cloneElement } from "react";
export type StepperProps = {
  activeStep?: number;
  children: React.ReactNode[];
};
export const Stepper = ({
  activeStep = 0,
  children
}: StepperProps) => {
  const childrenArray = React.Children.toArray(children);
  const steps = childrenArray.filter(step => isValidElement(step)).map((step, index) => cloneElement(step, {
    // Note - Use the <Step /> component because
    // it knows how to handle `active` prop
    active: activeStep === index,
    ...step.props
  }));
  return <>
      {steps}
    </>;
};